import { FlexBox, Typography, WarningTriangleIcon } from "@joonapp/web-shared"
import { UserRole } from "@joonapp/web-shared"
import { JoonUIColor } from "@joonapp/web-shared"
import { SPACING } from "@joonapp/web-shared"
import { ClientProfile } from "@joonapp/web-shared/dist/types/groups"
import { CoachProfile } from "@joonapp/web-shared/dist/types/groups"
import { CellContext } from "@tanstack/react-table"
import { useId } from "react"
import { Tooltip } from "react-tooltip"

import { ClientTableData } from "../../../types/misc"
import { checkCoachMessageAlerts } from "../../../util/sendbird"

export const LastMessageCell = (
  info: CellContext<
    ClientTableData,
    {
      date: string
      time: string | undefined
      sender: ClientProfile | CoachProfile | undefined
    }
  >
) => {
  const tooltipId = useId()
  const { date, time, sender } = info.getValue()

  const channel = info.row.original.channel
  const numUnreadMessages =
    channel.unreadMessageCount + channel.totalUnreadReplyCount

  const { showCoachMessageAlert, showClientMessageAlert, messageDaysAgo } =
    checkCoachMessageAlerts(
      sender,
      info.row.original.channel.lastMessage?.createdAt
    )

  return (
    <>
      <FlexBox
        direction="row"
        wrap={false}
        gap={SPACING.space05}
        data-tooltip-id={tooltipId}
        align="center"
        style={{
          position: "relative",
          width: "fit-content",
          whiteSpace: "nowrap",
          cursor: "pointer",
        }}
      >
        {(showCoachMessageAlert || showClientMessageAlert) && (
          <WarningTriangleIcon color={JoonUIColor.semantic.alert} size={12} />
        )}
        <Typography variant="bodySmall">
          {`${date}${time ? `, ${time}` : ""} - `}
        </Typography>
        <Typography
          variant="bodySmallBold"
          color={
            sender?.role === UserRole.COACH
              ? JoonUIColor.text.primaryAccent
              : JoonUIColor.text.primary
          }
        >
          {sender?.user.name ?? "Admin"}
        </Typography>
        {numUnreadMessages > 0 && (
          <FlexBox
            justify="center"
            align="center"
            style={{
              minWidth: SPACING.space4,
              width: "fit-content",
              background: JoonUIColor.semantic.primary,
              height: SPACING.space4,
              maxHeight: SPACING.space4,
              borderRadius: "50%",
              marginLeft: SPACING.space1,
            }}
          >
            <Typography variant="bodyXSmall" color={JoonUIColor.text.inverted}>
              {numUnreadMessages}
            </Typography>
          </FlexBox>
        )}
      </FlexBox>
      {(showCoachMessageAlert || showClientMessageAlert) && (
        <Tooltip id={tooltipId}>
          <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
            {showCoachMessageAlert &&
              `It has been ${messageDaysAgo} days since the last message`}
            {showClientMessageAlert && "Client is still waiting for a response"}
          </Typography>
        </Tooltip>
      )}
    </>
  )
}
